import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import AuthTalent from '../../services/AuthTalent'

const ProtectedRoute = ({ children, ...rest }) => (
  // if(rest.location.pathname !== '/app/home')
  <Route
    {...rest}
    render={({ location }) =>
      AuthTalent.loggedIn() ? (
        children
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: location },
          }}
        />
      )
    }
  />
)

export default ProtectedRoute
